export default __webpack_public_path__ + "static/media/sponsor-banner-cn-m.27611246.webp";